import { render, staticRenderFns } from "./Wp_home_more_model.vue?vue&type=template&id=171546d4&scoped=true&"
import script from "./Wp_home_more_model.vue?vue&type=script&lang=js&"
export * from "./Wp_home_more_model.vue?vue&type=script&lang=js&"
import style0 from "./Wp_home_more_model.vue?vue&type=style&index=0&id=171546d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171546d4",
  null
  
)

export default component.exports